import Settings from '@/views/Settings/index'
import UserInfo from '@/views/Settings/UserInfo'
import PasswordChange from '@/views/Settings/PasswordChange'
import SiteConfig from '@/views/Settings/SiteConfig'
import DataInit from '@/views/Settings/DataInit'
import ApiTest from '@/views/Settings/ApiTest'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    children: [
      {
        path: 'user-info',
        name: 'user-info',
        component: UserInfo
      },

      {
        path: 'password-change',
        name: 'password-change',
        component: PasswordChange
      },

      {
        path: 'site-config',
        name: 'site-config',
        component: SiteConfig
      },

      {
        path: 'data-init',
        name: 'data-init',
        component: DataInit
      },

      {
        path: 'api-test',
        name: 'api-test',
        component: ApiTest
      }
    ]
  }
]
